import { useState, useEffect } from 'react';

import { ArrowDownIcon, ArrowUpIcon } from './Icons/ArrowIcons';
import './AmountToggle.css'

const AmountToggle = (props) => {
  const { item, onClick, counts, isDesktop } = props;

  //TODO : менять цвет стрелки
  return (
    <div className='rntr-amount-toggle'>
      <div className='rntr-amount-toggle__buttons-block'>
        <button
          className='rntr-amount-toggle__button rntr-amount-toggle__button_up'
          onClick={ () => onClick(item, 'up') }>
          <ArrowUpIcon width='12px' height='8px' fill='000' />
        </button>
        <div className='rntr-amount-toggle__amount rntr-amount-toggle__amount_desc'>{ item.amount }</div>
        <button
          className='rntr-amount-toggle__button rntr-amount-toggle__button_down'
          onClick={ () => onClick(item, 'down') }>
          <ArrowDownIcon width='12px' height='8px' fill='000'/>
        </button>
      </div>
    </div>
  )
}

export default AmountToggle;
